/* global kopiostoL10n */

import { CookieBanner, NewsletterModal } from './popups.js';
// import {detect as detectBrowser} from 'detect-browser';

(function(window, document, $) {
    'use strict';

    CookieBanner.init();
    NewsletterModal.init();

    /**
     * Primary navigation toggle
     *
     * - call toggleShow()
     */
    $('.js-primary-nav-toggle').on('click', function() {
        toggleShow($(this), $('.js-primary-nav-wrapper'), false);
    });

    /**
     * Secondary navigation toggle
     *
     * - call toggleShow()
     */
    $('.js-secondary-nav-toggle').on('click', function() {
        toggleShow($(this), $('.js-secondary-nav'), false);
        //$(".secondary-nav-container__arrow-icon").toggleClass('flip');
    });

    /**
     * Primary submenu toggle
     *
     * - call toggleShow()
     */
    $('.js-submenu-toggle').on('click', function(e) {
        e.preventDefault();
        $(this).toggleClass('js-submenu-toggle--open');
        $(this).closest('li').children('.js-nav__submenu').toggle();
    });

    /**
     * Search form toggle
     *
     * - call toggleShow()
     */
    $('.js-search-toggle').on('click', function() {
        toggleShow($(this), $('.js-search-form'), $('.js-search-form').find('.js-search-field'));
    });

    /**
     * Language switcher toggle
     *
     * - call toggleShow()
     */
    $('.js-language-switcher-toggle').on('click', function() {
        toggleShow($(this), $('.js-site-lang__select--mobile'), false);
    });

    /**
     * Toggle open/closed
     *
     * - add/remove 'state-active' class to trigger element
     * - add/remove 'state-open' class to target element
     * - add 'aria-expanded' true/false to trigger element
     */

    function toggleShow($trigger, $target, $focus) {
        if ( $('.state-open').length && !$target.hasClass('state-open')) {
            $('.state-open').css('display', 'none').removeClass('state-open');
        }

        if ($trigger.length > 0 && $target.length > 0) {
            if ($target.hasClass('state-open')) {
                $target.css("display", "none").removeClass('state-open');
                $trigger.removeClass('state-active').attr('aria-expanded', false);
            } else {
                $target.css("display", "flex").addClass('state-open');
                $trigger.addClass('state-active').attr('aria-expanded', true);

                if ($focus && $focus.length > 0) {
                    $focus.focus();
                }
            }
        }
    }

    /* Handle accordion content visibility */

    function accordionHandler() {
        $('.js-accordion-toggle').each(function () {
            var accordionParent = $(this).parent();
            var accordion = $(this);

            $(this).on('click', function() {
                accordionParent.toggleClass('js-accordion-toggle--open');
                if (accordionParent.hasClass('js-accordion-toggle--open')) {
                    accordion.attr('aria-expanded', true);
                } else {
                    accordion.attr('aria-expanded', false);
                }
            });
        });
    }

    function accordionHandlerCookies() {
        $('.js-accordion-toggle-cookies').each(function () {
            var accordionParent = $(this).parent();
            var accordion = $(this);

            $(this).on('click', function() {
                accordionParent.toggleClass('js-accordion-toggle--open');
                if (accordionParent.hasClass('js-accordion-toggle--open')) {
                    accordion.attr('aria-expanded', true);
                } else {
                    accordion.attr('aria-expanded', false);
                }
            });
            $(this).on('keypress', function(event) {
                var keycode = (event.keyCode ? event.keyCode : event.which);
                    if(keycode == 13) {
                    accordionParent.toggleClass('js-accordion-toggle--open');
                    if (accordionParent.hasClass('js-accordion-toggle--open')) {
                        accordion.attr('aria-expanded', true);
                    } else {
                        accordion.attr('aria-expanded', false);
                    }
                }
            });
        });
    }

    accordionHandler();
    accordionHandlerCookies();

    /* Handle cookie accordion group */

    function accordionCookieGroupHandler() {
        $('.js-group-toggle').each(function () {
            var accordion = $(this).parents('.accordion__sub-title');

            $(this).on('click', function() {
                accordion.toggleClass('js-group-toggle--selected');
            });
        });
    }

    accordionCookieGroupHandler();

    /* Sidebar */

    function initSidebarHierarchy() {
        $('.js-article-sidebar ul li.page_item_has_children').each(function () {
            $(this).prepend( "<button class='children-toggle js-children-toggle' aria-expanded='false'><span class='toggle-sign'>+</span><span class='screen-reader-text'>" + kopiostoL10n.submenu_toggle + ' ' + $(this).find('a').html() + "</span></button>" );
        });
         $('.js-page-sidebar ul li.page_item_has_children').each(function () {
            $(this).prepend( "<button class='children-toggle js-children-toggle' aria-expanded='false'><span class='toggle-sign'>+</span><span class='screen-reader-text'>" + kopiostoL10n.submenu_toggle + ' ' + $(this).find('a').html() + "</span></button>" );
        });
    }

    initSidebarHierarchy();

    function sidebarHandler() {
        $('.js-children-toggle').each(function () {
            $(this).on('click', function() {
                if ($(this).hasClass('state-active')) {
                    $(this).removeClass('state-active').attr('aria-expanded', false);
                } else {
                    $(this).addClass('state-active').attr('aria-expanded', true);
                }
                $(this).siblings('.children').toggleClass('js-children--open');
                $(this).find('.toggle-sign').text(function(i, text){
                    return text === "+" ? "−" : "+";
                })
            });
        });
    }

    sidebarHandler();

    /* Open parent and children pages of the active page */

    function openSidebar() {
        $('.current_page_item').each(function () {
            $(this).children('a').addClass('current-color');
            $(this).children('.children').addClass('js-children--open');
            $(this).parents('.children').addClass('js-children--open');

            $(this).children('.js-children-toggle').each(function () {
                $(this).find('.toggle-sign').text(function(i, text){
                    return text === "+" ? "−" : "+";
                })
            });
        });
        $('.current_page_ancestor').each(function () {
            $(this).children('a').addClass('current-color');
            $(this).children('.js-children-toggle').each(function () {
                $(this).find('.toggle-sign').text(function(i, text){
                    return text === "+" ? "−" : "+";
                })
            });
        });
    }

    openSidebar();

    /* Share buttons */

    $('.js-share__btn').on('click', function() {
        $('.share-links').toggle();
    });


    /**
 * Make teaser div clickable
 */


    // Refactored by wrapping element with <a> tag as this method didn't work
    // when posts were filtered via js-masonry.
    // $('.teaser').on('click', function() {
    //     var first_href = $(this).find('a:first').attr('href');

    //     if(first_href) {
    //         window.location = $(this).find('a:first').attr('href');
    //         return false;
    //     }
    // });

    /* Newsfeed masonry */
    var $grid = $('.grid').masonry({
        itemSelector: '.teaser',
        columnWidth: '.hfeed--newsfeed .hentry',
        percentPosition: true,
    });

    // layout Masonry after each image loads
    $grid.imagesLoaded().progress( function() {
        $grid.masonry('layout');
    });

    /* Newsfeed & Juicer */

    if ($('div.article__newsfeed').length) {
        $('.site-content').css("background", "url('/app/themes/kopiosto/assets/images/bg-image-newsfeed.svg') center 400px / cover no-repeat");
    }
    if ($('div.article__somefeed').length) {
        $('.site-content').css("background", "url('/app/themes/kopiosto/assets/images/bg-image-newsfeed.svg') center 400px / cover no-repeat");
    }

    /* Newsfeed for AVEK */

    if ($('div.article__newsfeed--avek').length) {
        $('.site-content').css("background", "url('/app/themes/kopiosto/assets/images/bg-image-newsfeed-avek.svg') center 400px / cover no-repeat");
    }

    if ($('div.article__somefeed--avek').length) {
        $('.site-content').css("background", "url('/app/themes/kopiosto/assets/images/bg-image-newsfeed-avek.svg') center 400px / cover no-repeat");
    }

    /* Newsfeed filters */
    /* When loaded on desktop, details elements containing filters load open. */
    const newsfeedDetails = document.querySelectorAll('.newsfeed__details');

    if (newsfeedDetails.length > 0 && window.innerWidth >= 1024) {
        newsfeedDetails.forEach(detail => {
            detail.setAttribute('open', true);
        });
    }

    $('.js-filterposts').on('click', function(e) {
        e.preventDefault();
        $('.js-content-updated').removeClass('state-filtered__active');

        $('.js-content-updated').toggleClass('state-filtered__active');
        const $btn = $(this);

        if ($btn.hasClass('newsfeed__filter--cat')) {
        $btn.closest('.newsfeed__filters--cat')
            .find('.newsfeed__filter--cat')
            .removeClass('active');
        $btn.addClass('active');
        }

        if ($btn.hasClass('newsfeed__filter--year')) {
        $btn.closest('.newsfeed__filters--year')
            .find('.newsfeed__filter--year')
            .removeClass('active');
        $btn.addClass('active');
        }
        
        $('.js-loadmore').attr("data-page","1").show();

        var category_id = $(".newsfeed__filter--cat.active").attr("data-cat-id");
        var publish_year = $(".newsfeed__filter--year.active").attr("data-cat-year");
        var first_page = $('.js-loadmore').attr("data-page");
        var post_type = $('.site-wrapper').attr("data-post-type");
        var currentLang = $('html').attr('lang').substring(0, 2);

        // ajax-loadposts.php
        $.ajax({
            url: ajax_object.url, // eslint-disable-line
            type: 'post',
            data: {
                action: 'ajax_load_posts',
                tax: category_id,
                year: publish_year,
                page: first_page,
                post_type: post_type,
                lang: currentLang,
            },
            success: function(result) {
                //$('.hfeed').html(result);
                var $obj = $('.teaser');
                $grid.masonry( 'remove', $obj);
                var $newItems = $(result);
                $grid.append($newItems).masonry( 'appended', $newItems ).masonry('layout');
                setTimeout(function() {
                    $grid.imagesLoaded().progress( function() {
                        $grid.masonry('layout');
                    });
                }, 100);
                if ($newItems.length < 20) {
                    $('.js-loadmore').hide();
                }
            },
        });

    });

    /* Newsfeed load more */

    $('.js-loadmore').on('click', function(e) {
        e.preventDefault();

        var category_id = $(".newsfeed__filter--cat.active").attr("data-cat-id");
        var publish_year = $(".newsfeed__filter--year.active").attr("data-cat-year");
        var current_page = $(this).attr("data-page");
        var next_page = Number(current_page) + 1;
        var post_type = $('.site-wrapper').attr("data-post-type");
        var currentLang = $('html').attr('lang').substring(0, 2);

        $(this).attr("data-page", next_page);

        // ajax-loadposts.php
        $.ajax({
            url: ajax_object.url, // eslint-disable-line
            type: 'post',
            data: {
                action: 'ajax_load_posts',
                tax: category_id,
                year: publish_year,
                page: next_page,
                post_type: post_type,
                lang: currentLang,
            },
            success: function(result) {
                //$('.hfeed').append(result);

                var $content = $( result);
                $grid.append( $content ).masonry( 'appended', $content ).masonry('layout');
                setTimeout(function() {
                    $grid.imagesLoaded().progress( function() {
                        $grid.masonry('layout');
                    });
                }, 100);

                if (!result.length) {
                    $('.js-loadmore').hide();
                }
            },
        });
    });

    // iOS hack: Add an optgroup to c-info gravityform select in order to avoid truncating the content
    if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
        var selects = document.querySelectorAll(".single-cinfo select");
        for (var i = 0; i < selects.length; i++ ){
            selects[i].appendChild(document.createElement("optgroup"));
        }
    }

})(window, document, jQuery);

/* Gravity Forms progress bar */
const progressBar = document.querySelector('.gf_progressbar.gf_progressbar_custom');
const gformBody = document.querySelector('.gform-body, .gform_body');

if (progressBar && gformBody) {
    gformBody.parentNode.insertBefore(progressBar, gformBody.nextSibling);
}

/* Desktop primary navigation toggle */

$('.js-primary-nav').hover(function() {
    if ($(document).width() > 1024) {
        $('.nav--primary__submenu').not( ".nav__submenu--c-info" ).show();
    }
},function() {
    if ($(document).width() > 1024) {
        $('.nav--primary__submenu').not( ".nav__submenu--c-info" ).hide();
    }
});

jQuery(document).ready(function($) {

    /* Slick carousel slider */

    // Slick expects direct children as slides. Accepts <figure> or <div>.
    $('.carousel').slick({
        autoplay: true,
        arrows: true,
        dots: true,
        infinite: true,
        pauseOnFocus: true,
        pauseOnHover: true,
        autoplaySpeed: 5000,
        accessibility: true,
        adaptiveHeight: true,
        // slide: undefined (default) - all direct children
    });

    /* $('.testimonial-component__carousel').slick({
        autoplay: true,
        arrows: false,
        dots: true,
        infinite: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        autoplaySpeed: 5000,
    }); */

    $('#play').click(function() {
        $('.carousel').slick('slickPlay');
        $('#play').css('display', 'none');
        $('#pause').css('display', 'inline-block');
    });

    $('#pause').click(function() {
        $('.carousel').slick('slickPause');
        $('#play').css('display', 'inline-block');
        $('#pause').css('display', 'none');
    });

     /* Search */

    $('form[name="search-header"]').submit(function(e) {
        e.preventDefault();
        var query = $(this).find('input[name="s"]').val();
        var lang = $('html').attr("lang").substring(0, 2)
        if (lang == 'fi') {
            lang = '';
        } else {
            lang = lang.concat('/');
        }
        window.location = location.protocol + '//' + location.host + '/' + lang + '?s=' + query + '&search=' + $('.site-wrapper').attr("data-post-type");
    });

    /* Search archive */

    $('.js-filtersearch').on('click', function() {
        $(this).siblings().removeClass("active");
        $(this).addClass("active");
        $('form[name="search-archive"]').submit();
    });

    $('.js-filtersearch').on('click', function() {
        $(this).siblings().removeClass("active");
        $(this).addClass("active");
        $('form[name="search-archive"]').submit();
    });

    $('.js-linksearch').on('click', function(e) {
        e.preventDefault();
        $('.site-wrapper').attr("data-post-type", $(this).attr("data-type"));
        $('form[name="search-archive"]').submit();
    });

    $('form[name="search-archive"]').submit(function(e) {
        e.preventDefault();
        var query = $(this).find('input[name="s"]').val();
        let filter = $('.js-filtersearch.active').attr('data-filter') || "";
        let searchParams = new URLSearchParams(window.location.search);
        let tag = searchParams.get('tag') || "";
        var lang = $('html').attr("lang").substring(0, 2)
        if (lang == 'fi') {
            lang = '';
        } else {
            lang = lang.concat('/');
        }
        window.location = location.protocol + '//' + location.host + '/' + lang + '?s=' + query + '&search=' + $('.site-wrapper').attr("data-post-type") + '&filter=' + filter + '&tag=' + tag;
    });


    /* Hero arrow */

    setTimeout(function() {
        $('.hero__arrow').fadeIn(200);
    }, 4000);

    $('.hero__arrow').on('click', function() {
        var vheight = $(window).height();
        $('html, body').animate({
            scrollTop: (Math.floor($(window).scrollTop() / vheight)+1) * vheight,
          }, 1000);
    });

    $(window).scroll(function() {
        $('.hero__arrow').fadeOut(200);
    });
});


/* Accessible image modal logic for accordion images */
document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('image-modal');
  if (!modal) return;

  const modalImage = modal.querySelector('.modal-image');
  const closeModalBtn = modal.querySelector('.modal-close');
  let lastFocusedElement = null;

  function trapFocus(e) {
    if (e.key === 'Tab') {
      e.preventDefault();
      closeModalBtn.focus();
    }
    if (e.key === 'Escape') {
      closeModal();
    }
  }

  function openModal(src, alt) {
    lastFocusedElement = document.activeElement;

    modalImage.src = src;
    modalImage.alt = alt;
    modal.hidden = false;
    modal.classList.add('open');
    document.body.style.overflow = 'hidden';
    closeModalBtn.focus();

    document.addEventListener('keydown', trapFocus);
  }

  function closeModal() {
    modal.classList.remove('open');
    modal.hidden = true;
    modalImage.src = '';
    modalImage.alt = '';
    document.body.style.overflow = '';

    if (lastFocusedElement) lastFocusedElement.focus();
    document.removeEventListener('keydown', trapFocus);
  }

  closeModalBtn.addEventListener('click', closeModal);
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      closeModal();
    }
  });

  const accordionPanels = document.querySelectorAll(
    '.accordion-item__panel img, .icon-accordion-item__panel img'
  );

  accordionPanels.forEach(img => {
    if (!img.closest('.image-wrapper')) {
      const wrapper = document.createElement('div');
      wrapper.classList.add('image-wrapper');

      const magnifyIcon = document.createElement('span');
      magnifyIcon.className = 'magnify-icon';
      magnifyIcon.setAttribute('aria-hidden', 'true');

      img.parentNode.insertBefore(wrapper, img);
      wrapper.appendChild(img);
      wrapper.appendChild(magnifyIcon);

      img.classList.add('js-modal-trigger');
      img.setAttribute('role', 'button');
      img.setAttribute('tabindex', '0');
      img.setAttribute('aria-label', 'Avaa kuva suuremmaksi');
    }
  });

  document.querySelectorAll('.js-modal-trigger').forEach(img => {
    img.addEventListener('click', () => openModal(img.src, img.alt));
    img.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openModal(img.src, img.alt);
      }
    });
  });
});
